import styled from "styled-components";
export const TableFather = styled.div`
  .card {
    /* margin-top: 20px; */
    font-size: 14px;
    background-color: ${({ theme }) => theme.backgroundSidebar};
    border: none;
    box-shadow: ${({ theme }) => theme.shadow};
    border-radius: 10px;
    .card-body {
      height: ${({ scroll }) => (scroll ? "400px" : "100%")};
      overflow-y: scroll;
      height: ${(props) => (props.CrmUsers ? "100%" : "")};
    }
    /* padding: 1rem 0; */
    /* width */

    div::-webkit-scrollbar {
      height: 7px;
    }
    div::-webkit-scrollbar-track {
      border-radius: 10px;

      webkit-box-shadow: inset 0 0 6px gray;
    }
    div::-webkit-scrollbar-thumb {
      background-color: a6c53b;

      webkit-box-shadow: inset 0 0 6px gray;
    }

    .w-100 {
      padding: 17px;
      padding-top: 10px;
      padding-bottom: 10px;
      background-color: ${({ theme }) => theme.inputField};
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      /* border-top: 1px solid #b9b9b9; */
      margin-bottom: 15px;
    }
    .card-header {
      padding: 0px !important;
      background-color: ${({ theme }) => theme.backgroundSidebar};
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;

      .card-toolbar {
        margin: 1rem;
      }
      .search-field {
        background-color: ${({ theme }) => theme.inputField};
        display: flex;
        border-radius: 10px;
        padding: 3px 5px;
        width: 270px;
        /* color: ${({ theme }) => theme.text}; */
        .icon {
          margin: 10px;
          background-color: transparent;
          font-size: 20px;
        }
        .tableSearchInput {
          color: #5e6278;
          transition: color 0.2s ease, background-color 0.2s ease;
          border: none;
          background-color: transparent;
          width: 250px;
          &:focus {
            box-shadow: none;
          }
        }
      }
      .pagination-rate {
        select {
          color: ${({ theme }) => theme.text};
          background-color: ${({ theme }) => theme.inputField};
        }
      }
    }
    .table {
      border-collapse: unset;
      thead {
        tr {
          th {
            border: none;
            color: ${({ theme }) => theme.greytext};
            .form-check {
              display: flex;
              input {
                width: 1.5rem;
                height: 1.5rem;
                background-color: #eff2f5;
                border: none;
                &:checked {
                  background-color: #009ef7;
                }
                &:focus {
                  outline: none;
                  box-shadow: none;
                }
              }
            }
          }
        }
      }
      tbody {
        tr {
          td {
            border-bottom: 1px dashed ${({ theme }) => theme.border} !important;
            border: none;
            .badging {
              color: #fff !important;
            }
            span {
              color: ${({ theme }) => theme.text} !important;
            }
            border: none;
            .form-check {
              display: flex;
              input {
                width: 1.5rem;
                height: 1.5rem;
                background-color: #eff2f5;
                border: none;
                &:checked {
                  background-color: #009ef7;
                }
                &:focus {
                  outline: none;
                  box-shadow: none;
                }
              }
            }
          }
        }
      }
    }
    .card-footer {
      background-color: ${({ theme }) => theme.backgroundSidebar};
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      .pagination {
        width: fit-content;
        li {
          a {
            background-color: ${({ theme }) => theme.backgroundSidebar};
          }
        }
      }
    }
  }
`;

export const ListImages = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 1rem;
  height: 400px;
  overflow-y: auto;
  img {
    width: 100px;
    height: 100px;
    object-fit: cover;
  }
`;

export const ProductCard = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem;
  box-shadow: ${({ theme }) => theme.shadow};
  padding: 0.2rem;
`;

export const ProductFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.2rem;
  background-color: #138496;
  padding: 0.2rem;
  span {
    font-size: 12px;
    font-weight: bold;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 205px;
  margin: 0 1rem;
  justify-content: space-between;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;
